import { getPropertiesByProjectRepository } from "../Infrastructure/Properties.repository";

export async function getPropertiesByProjectLogic(projectId, params) {
  return getPropertiesByProjectRepository(projectId, params);
}
